import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import ContentWrapper from "../../../Wrapper";
import AccountDetailsSubheader from "../../components/account-details-subheader";
import { getListOfRcsBotConfigsRequest, addRcsBotConfigRequest, deleteRcsBotConfigRequest } from "../../store/actions/account_rcs_bot_configs_actions";
import { Button, Modal, Form, } from 'react-bootstrap';
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import AccountRcsBotConfigSidePanel from "./components/account-campaign-rcs-bot-config-side-panel";
import SenderIdCountrySelect from "./sender-id-country-select";
import { COUNTRIES } from "../../../../constants";

const ACCOUNT_RCS_BOT_CONFIG_ACTIONS = {
    NONE: "NONE",
    EDIT: "EDIT",
    DELETE: "DELETE"
};

export default function RCSBotConfiguration({ match }) {

    const tabName = "RCS Bot Configuration";
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [selectedBotWithAction, setBotWithAction] = useState({
        action: ACCOUNT_RCS_BOT_CONFIG_ACTIONS.NONE,
        data: {},
    });

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        botName: '',
        brandLogo: '',
        botId: '',
        botSecret: '',
        vendor: 'VI',
        supportedCountry: 'IN'
    });

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [botToDelete, setBotToDelete] = useState(null);

    const [selectedCountry, setSelectedCountry] = useState([]);

    const rcsBotConfigs = useSelector((state) => state.accounts.accountRcsBotConfig);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListOfRcsBotConfigsRequest({ limit: limit, pageNo: page, accountId: match.params.accountId }));
    }, [dispatch, limit, page, match.params.accountId, rcsBotConfigs.data.length]);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleShowConfirmModal = (bot) => {
        setBotToDelete(bot);
        setShowConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setShowConfirmModal(false);
        setBotToDelete(null);
    };

    const handleConfirmDelete = () => {
        if (botToDelete) {
            dispatch(deleteRcsBotConfigRequest({ settingId: botToDelete._id, accountId: match.params.accountId }));
        }
        handleCloseConfirmModal();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        formData['accountId'] = match.params.accountId;
        const updatedCountries = selectedCountry.map(country => country.value);
        formData['supportedCountry'] = updatedCountries;
        dispatch(addRcsBotConfigRequest(formData));
        handleCloseModal();
    };

    const formatData = data => {
        return data.map(item => ({
            ...item,
            supportedCountry: item.supportedCountry.join(', ')  // Example conversion
        }));
    };

    const formattedData = formatData(rcsBotConfigs.data);
    return (
        <ContentWrapper subHeader={<AccountDetailsSubheader active={tabName} />}>

            <div className="d-flex justify-content-end mb-5">
                <Button variant="primary" onClick={handleShowModal} >Add New RCS Bot </Button>
            </div>

            {/* Modal for Adding New Bot */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New RCS Bot</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBotName">
                            <Form.Label>Bot Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter bot name"
                                name="botName"
                                value={formData.botName}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBrandLogo">
                            <Form.Label>Brand Logo URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter brand logo URL"
                                name="brandLogo"
                                value={formData.brandLogo}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBotId">
                            <Form.Label>Bot ID</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter bot ID"
                                name="botId"
                                value={formData.botId}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBotSecret">
                            <Form.Label>Bot Secret</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter bot secret"
                                name="botSecret"
                                value={formData.botSecret}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formVendor">
                            <Form.Label>Vendor</Form.Label>
                            <Form.Control
                                as="select"
                                name="vendor"
                                value={formData.vendor}
                                onChange={handleChange}
                            >
                                <option value="VI">VI</option>
                                <option value="GOOGLE">GOOGLE</option>
                                <option value="FAKE">FAKE</option>
                                <option value="JIO">JIO</option>
                            </Form.Control>
                        </Form.Group>

                        <SenderIdCountrySelect options={COUNTRIES} selectedValue={selectedCountry} setSelectedValue={setSelectedCountry} />

                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Confirmation Modal for Deleting Bot */}
            <Modal show={showConfirmModal} onHide={handleCloseConfirmModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this bot?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirmModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleConfirmDelete}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>

            {rcsBotConfigs.loading ? (
                <ContentWithCardLoading />
            ) : (

                <div className={`card card-custom`}>
                    <div className="card-body py-3 px-3" style={{ padding: 15 }}>
                        {rcsBotConfigs.data.length === 0 ?
                            (<div className="text-center">No data found</div>)
                            : (<AdvanceDataTable
                                columns={[
                                    { title: "Bot Name", apiKeyName: "botName", fieldInputType: "INPUT" },
                                    { title: "Brand Logo", apiKeyName: "brandLogo", fieldInputType: "INPUT" },
                                    { title: "Vendor", apiKeyName: "vendor", fieldInputType: "SELECT" },
                                    { title: "Supported Country", apiKeyName: "supportedCountry", fieldInputType: "SELECT" },
                                    { title: "Action", isAction: true, options: ["edit", "delete"] },
                                ]}
                                data={formattedData}
                                limit={limit}
                                pageNo={page}
                                setPageNo={setPage}
                                setLimit={setLimit}
                                count={rcsBotConfigs.data.length}
                                // actions
                                handleEdit={(data) => setBotWithAction({ action: ACCOUNT_RCS_BOT_CONFIG_ACTIONS.EDIT, data })}
                                handleDelete={(data) => handleShowConfirmModal(data)}
                            />)}

                    </div>
                </div>
            )}


            <AccountRcsBotConfigSidePanel
                show={selectedBotWithAction.action === ACCOUNT_RCS_BOT_CONFIG_ACTIONS.EDIT}
                rcsBotConfigData={selectedBotWithAction.data}
                handleClose={() => setBotWithAction({ action: ACCOUNT_RCS_BOT_CONFIG_ACTIONS.NONE, data: {} })}
            />
        </ContentWrapper>
    );
}